import React, { useEffect, useState } from 'react';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'
import CurrencyFormat from "react-currency-format";

export default function AceptarCreditoCS({ creditoAutorizado, isMobile, aceptarCredito }) {

    return (
        <>
            {isMobile === "desktop"
                ?
                    <>
                        <div className='formasPagoTienda boderHome'>

                            <div className='contenedor1'>
                                <h1 className='principal'>¡Felicidades, por ser un cliente excelente ya cuentas con tu</h1>
                                <h1 className='principal2'><span className='colorRojo'>Crédito Claroshop Preaprobado</span></h1>

                                <div className='cajaInterna'>
                                    <p className='subt'>Crédito preaprobado</p>
                                    <h1 className='bold colorRojo marginTop10 creditoMonto'>
                                        <CurrencyFormat
                                            value={Number(creditoAutorizado)}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            prefix={'$'}
                                            renderText={value => <span className="strong">{value}</span>}
                                        />
                                    </h1>

                                    <div className='boxBtn'>
                                        <button onClick={aceptarCredito} className='btn rojo btnAceptar'>Quiero mi Crédito Claroshop</button>
                                    </div>

                                    <div className='terminos'>
                                        <p className='marginBottom20'>Al dar clic, aceptas los
                                            <a href={`${BASE_PATH}contrato-credito`} className='linkRojo'>Términos y condiciones</a>
                                        </p>
                                    </div>
                                </div>

                                <div className='cajaExterna'>
                                    <p>Beneficios</p>
                                    <ul className='ulBene'>
                                        <li className='liBene'>Paga cualquier producto a parcialidades</li>
                                        <li className='liBene'>Sólo aceptalo y estarás listo para compra</li>
                                    </ul>
                                </div>
                            </div>

                        </div>
                    </>
                :
                    <div className='formasPagoTienda '>
                        <div className='contenedor1'>
                            <h1 className='principal'>¡Felicidades, por ser un cliente excelente ya cuentas con tu</h1>
                            <h1 className='principal2'><span className='colorRojo'>Crédito Claroshop Preaprobado</span></h1>

                            <div className='cajaInterna'>
                                <p className='subt'>Crédito preaprobado</p>
                                <h1 className='bold colorRojo marginTop10 creditoMonto'>
                                    <CurrencyFormat
                                        value={Number(creditoAutorizado)}
                                        displayType={'text'}
                                        thousandSeparator={true}
                                        prefix={'$'}
                                        renderText={value => <span className="strong">{value}</span>}
                                    />
                                </h1>

                                <div className='boxBtn'>
                                    <button onClick={aceptarCredito} className='btn rojo btnAceptar'>Quiero mi Crédito Claroshop</button>
                                </div>

                                <div className='terminos'>
                                    <p className='marginBottom20'>Al dar clic, aceptas los
                                        <a href={`${BASE_PATH}contrato-credito`} className='linkRojo'>Términos y condiciones</a>
                                    </p>
                                </div>
                            </div>

                            <div className='cajaExterna'>
                                <p>Beneficios</p>
                                <ul className='ulBene'>
                                    <li className='liBene'>Paga cualquier producto a parcialidades</li>
                                    <li className='liBene'>Sólo aceptalo y estarás listo para compra</li>
                                </ul>
                            </div>
                        </div>
                    </div>
            }
        </>
    )
}